var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"warning banner",staticStyle:{"display":"none"},attrs:{"id":"feature-availability-warning-dialog"}},[_c('strong',[_vm._v("The following features of this form are not available on your current plan:")]),_vm._v(" "),_c('ul',{attrs:{"id":"feature-not-available-list"}})])
}]

export { render, staticRenderFns }